export default {
  Confirm: 'Bestätigen',
  Cancel: 'Stornieren',
  'The minimum time length is xxxs!': 'Die minimale Zeitdauer beträgt {{num}}s!',
  'The maximum time length is 50s!': 'Die maximale Zeitdauer beträgt 50s!',
  'Online service, no download required': 'Online-Service, kein Download erforderlich',
  'Add up to 20MB file': 'Maximal 20 MB Datei hinzufügen',
  'Support common formats': 'Gängige Formate werden unterstützt',
  'Best for general editing requirements': 'Das Beste für allgemeine Bearbeitungs-Anforderungen',
  '0 second wait': '0 Sekunde Wartung',
  'No size limits': 'Keine Größenbeschränkungen',
  'Support 1000+ formats': '1000+ Formate werden unterstützt',
  'Stable processing': 'Stabile Verarbeitung',
  'Get access to HitPaw Toolkit!': 'Zugriff auf HitPaw Toolkit!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'Unterstützung für Schneiden, Zuschneiden & Drehen, Anpassen, Geschwindigkeit, Musik, Stop-Motion usw.',
  'The easiest video editing software for beginners':
    'Die einfachste Videobearbeitungssoftware für Anfänger',
  'Remove watermark from videos and images in simple clicks':
    'Wasserzeichen von Video- und Bild entfernen mit Klicks',
  'TRY IT FREE': 'KOSTENLOS TESTEN',
  'BUY NOW': 'JETZT KAUFEN',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'Erfolgreich analysiert! Ihre Datei ist größer als 100 MB und kann von HitPaw Online nicht bearbeitet werden. ',
  'download the video': 'Laden Sie bitte das Video herunter',
  'and then use HitPaw Toolkit to proceed.': ' und bearbeiten mit dem HitPaw Toolkit.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Schneiden Sie höchstens 10 Video Fragmente. Holen Sie sich das HitPaw Toolkit für weitere Funktionen.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'Die Dateigröße darf nicht größer als 20MB sein. Holen Sie sich das HitPaw Toolkit für weitere Funktionen.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'Die minimale Zeitdauer beträgt 1s! Holen Sie sich das HitPaw Toolkit für weitere Funktionen.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'Fügen maximal 3 Videos hinzu. Holen Sie sich das HitPaw Toolkit für weitere Funktionen.',
  'This format is not supported currently.': 'Dieses Format wird derzeit nicht unterstützt.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'Dieses Format wird derzeit nicht unterstützt. Holen Sie sich das HitPaw Toolkit für weitere Funktionen.',
  'Processing failed. Get HitPaw Toolkit for stable processing.':
    'Video konnte nicht generiert werden!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.':
    'Laden ist fehlgeschlagen!',
  'Are you sure you want to delete it?': 'Möchten Sie es wirklich löschen?',
  'Failed to extract the audio!': 'Audio konnte nicht extrahiert werden!',
  'Coming Soon': 'Kommt bald',
  'Learn more': 'Mehr erfahren',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'Maximal x Dateien hinzufügen. Holen Sie sich das HitPaw Toolkit für weitere Funktionen.',
  Download: 'Herunterladen',
  'Try Again': 'Erneut Versuchen',
  Failed: 'Fehlgeschlagen',
  'Get Started': 'Loslegen',
  Start: 'Starten',
  End: 'Enden',
  Export: 'Exportieren',
  'Your audio is ready!': 'Ihr Audio ist fertig!',
  'Download Audio': 'Audio herunterladen',
  YES: 'JA',
  'Export Failed': 'Export ist fehlgeschlagen',
  'Error occurs, the file cannot be added':
    'Fehlgeschlagen, die Datei kann nicht hinzugefügt werden',
  'Support merging audio files at most':
    'Unterstützt das Zusammenführen von höchstens {{num}} Audiodateien',
  'Are you sure you want to delete this task?': 'Möchten Sie diese Aufgabe wirklich löschen?',
  Processing: 'Verarbeiten',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'Vergessen Sie nicht, Ihre Datei herunterzuladen, sie wird 24 Stunden später im Überfluss vorhanden sein.',
  Uploading: 'Wird hochgeladen',
  'Go Edit': 'zur Bearbeitung gehen',
  'Generate Files Successfully!': 'Dateien werden erfolgreich generiert!',
  'Your order is being paid...': 'Ihre Bestellung wird bezahlt',
  'Not yet': 'Noch nicht',
  'Payment completed': 'Ja',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
